import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SuccessIcon from "../../resources/icons/success.svg";
import AuthContext from "../../store/auth-context";
import ToolTip from "../../common/ToolTip/ToolTip";
import { useTranslation } from "react-i18next";
import { pageRootTestIds } from "../../testing/pageRootTestIds";

const SuccessEmailIdentity = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const authContext = useContext(AuthContext);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const params = {};
    queryParams.forEach((value, key) => {
      params[key] = value;
    });
  }, [location]);

  const handleTestEmailClick = () => {
    navigate("/issuer/settings?section=email-address");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4" id={pageRootTestIds.successEmailIdentity}>
      <div className="w-full bg-white max-w-md rounded-lg shadow-lg">
        <div className="flex flex-col items-center space-y-6 p-6">
          <img src={SuccessIcon} height={65} width={65} alt="Success Icon" />
          <h1 className="text-2xl font-bold text-center text-gray-900">
            {t("authPages:email_verified_success")}
          </h1>
          <p className="text-center text-gray-600">
            {t("authPages:email_verified_desc")}
          </p>
          {authContext.isLoggedIn ? (
            <button
              onClick={handleTestEmailClick}
              id="success-email-identity-test-email"
              className="w-[50%] px-4 py-2 rounded-md font-medium text-cfSecondary bg-cfPrimaryButton transition-colors duration-200 ease-in-out hover:bg-cfPrimaryDarkBlue"
            >
              {t("authPages:test_email")}
            </button>
          ) : (
            <ToolTip
              component={
                <button
                  disabled
                  id="success-email-identity-test-email-disabled"
                  className="w-full px-4 py-2 rounded-md font-medium text-cfSecondary bg-cfIssuedScreenTabButtonUnSelectedText"
                >
                  {t("authPages:test_email")}
                </button>
              }
              message={t("authPages:signin_test_email")}
              tooltipPosition={"top-[-2.8rem]"}
              bgColor={"#E0781A"}
              tooltipWidth={"max-w-[300px]"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessEmailIdentity;
